import React, {useEffect, useState} from "react";
import {Grid} from "tabler-react";
import ReactHLS from 'react-hls';
import { Crud_Catalogos } from '../herramientas/Crud_Catalogos';
import Select from "react-select";
import axios from 'axios';
import "./LiveVideo.css";
// http://localhost:3000/live?token=KKLHjlHke_tqcw9xlHC2Y3dm0D9QmFwA16buOxl8yhk=&dispositivo=1

// https://cctv.skyangel.com.mx/hls/MV8x.m3u8
// https://cctv.skyangel.com.mx/hls/stream.m3u8
let stream= {};
let playing= { play: false, stop: false, wait: false};
const LiveVideo =({ dispositivo, token, canal })=> {
  const [unidad, setUnidad]= useState({});
  const [currenCanal, setCurrenCanal]= useState({ value: 0, label: "Selecciona un canal", data: null});
  const [canales, setCanales]= useState([]);
  const [playingState, setPlayingState]= useState({ play: false, stop: false, wait: false});
  const [online, setOnline]= useState(false);
  const [respuesta, setRespuesta]= useState({});
  useEffect(() => {
    Crud_Catalogos("dispositivos/live/unidades/estatus/"+ dispositivo, "get", "", "").then((returnVal) => {
      setOnline(returnVal.estatus? true: false);
    }).catch(err =>{ alert("A ocurrido un error al obtener el estatus")});
  },[]);

  useEffect(() => {
    if(playingState.wait){
      isPlaying();
    }
  },[playingState]);

  useEffect(() => {
    if(online){
      if( canal && canal.canal){
        alert("getStream");
        setCurrenCanal({ value: canal.canal, label: canal.nombre, data: canal});
        getStream(canal);
      }
      if(
          false && //Object.keys(objeto).length
          sessionStorage.getItem("livePage")
          && (new Date().getTime() - new Date(sessionStorage.getItem("playTime")).getTime())< (1000*60*3)
        ){//Recuperar seccion
          alert("refresh..!!");
          setUnidad(JSON.parse(sessionStorage.getItem("Unidades")));
          setCanales(JSON.parse(sessionStorage.getItem("canales")));
      }else{//Inicio normal
        sessionStorage.setItem("livePage", true);
        Crud_Catalogos("dispositivos/live/unidades/"+dispositivo, "get", "", "").then((returnUnidades) => {
          stream= {};
          setUnidad(returnUnidades);
          sessionStorage.setItem("Unidades", JSON.stringify(returnUnidades));
          //window.location.reload();
          let canalesTemp= [{ value: 0, label: "Selecciona un canal", data: null},]
          Crud_Catalogos("dispositivos/live/canales/"+dispositivo, "get", "", "").then((returnCanales) => {
            for( let c of returnCanales){
              if( c.idDispositivo ){
                stream[c.canal]= null;
                canalesTemp.push({ value: c.canal, label: c.nombre, data: c});
              }
            }
            setCanales( returnCanales.length? canalesTemp: []);
            sessionStorage.setItem("canales", JSON.stringify(returnCanales.length? canalesTemp: []));
          }).catch(err =>{ console.log(err); alert("A ocurrido un error: canales")});
        }).catch(err =>{ alert("A ocurrido un error: unidades")});
      }
    }
  },[online]);
  /*
  {
    "id": 1,
    "identificador": "0099002FD8",
    "nombre": "nombre",
    "proveedor": {
        "id": 1,
        "nombre": "epcom Ceiba2",
        "url": "http://189.206.106.34",
        "puerto": 12056,
        "username": "Skyangel",
        "password": "sky2019mdr"
    },
    "grupo": "SkyAngel"
  }
  {
    "idDispositivo": 1,
    "canal": 1,
    "nombre": "Puerta",
    "descripcion": "Chofer"
  }
  */
  const getPlaying=()=> {return playing};
  const isPlaying=()=>{
    delete axios.defaults.headers.common["Authorization"];
      if(playing.wait){//stream[currenCanal.data.canal].url
        if( currenCanal.data.canal && stream[currenCanal.data.canal] && stream[currenCanal.data.canal].url ){
          axios.get(stream[currenCanal.data.canal].url).then(res => {
            playing.play= true;
            playing.wait= false;
            stream[currenCanal.data.canal].mensaje= "Reproduccionedo";
            setRespuesta({...stream});
            setPlayingState({...playing});
            //return res.data;
          }).catch(err =>{
            console.log(err);
          });
        }
      }
      if(playing.play){
        if( currenCanal.data.canal && stream[currenCanal.data.canal] && stream[currenCanal.data.canal].url ){
          axios.get(stream[currenCanal.data.canal].url).then(res => {
          }).catch(err =>{
            playing.play= false;
            playing.stop= true;
            stream[currenCanal.data.canal].mensaje= "Reprodución finalizada";
            setRespuesta({...stream});
            setPlayingState({...playing});
          });
        }
      }
      setTimeout(() => {
        if(playing.wait || playing.play){
          isPlaying();
        }
      }, 3000);
  }

  const getStream =( c )=>{
    playing= { play: false, stop: false, wait: true};
    setPlayingState({...playing});
    stream= {};
    if( c.idDispositivo ){
      Crud_Catalogos(
        "dispositivos/live/video"
        +"?dispositivo="+dispositivo
        +"&canal="+c.canal
        +"&audio=true"
        +"&st=1"// 0: mainstream, 1: substream
        +"&puerto=12060&key="+token
        , "get", "", "").then((returnStream) => {
          stream[c.canal]= {};
          if( returnStream.codigo && returnStream.codigo === 200){
            stream[c.canal].url= returnStream.url;
            stream[c.canal].mensaje= returnStream.mensaje;
          }else{
            stream[c.canal]= returnStream;
          }
      }).catch(err =>{ alert("A ocurrido un error")});
    }
    setRespuesta(stream);
    sessionStorage.setItem("stream", JSON.stringify(stream));
    sessionStorage.setItem("playTime", new Date());
  }

  return (
    <>{/*
      <h1>{token}</h1>
      <h1>{dispositivo}</h1>
      */}
      <div>
        <div>
        <span className="badge">
          <i className= {"fa fa-camera "+(online?"text-success":"text-secondary")} style={{"font-size":"24px"}}></i>
        </span>
          <span>{ unidad.grupo? unidad.grupo: ""} <i class="fa fa-angle-double-right mr-2"></i> </span>
          <span>{ unidad.nombre? unidad.nombre: ""} <i class="fa fa-angle-double-right mr-2"></i> </span>
          <span>{ unidad.identificador? unidad.identificador: ""} </span>
        </div>
        <div>
          <div class="form-group">
            <label for="Canal">Camara</label>
            <Select value={ currenCanal }
              onChange={ (e)=>{
                setCurrenCanal(e);
                getStream(e.data);
              }}
              options={ canales } />
          </div>
        </div>
        <div className="row">
          <div class={"col-sm-12"}>{console.log("<== ",currenCanal.value && respuesta[currenCanal.data.canal] && respuesta[currenCanal.data.canal].url && playingState.play, " ==>")}
            { currenCanal.value && respuesta[currenCanal.data.canal] && respuesta[currenCanal.data.canal].url && playingState.play?//.includes("https")
                <div class="text-center" key={currenCanal.data.canal}>
                  <span>
                    <span className="mr-1"> Canal: </span>
                    <span>{ currenCanal.data.canal } <i class="fa fa-angle-double-right mr-2"></i> </span>
                    <span>{ currenCanal.data.nombre } <i class="fa fa-angle-double-right mr-2"></i> </span>
                    <span>{ currenCanal.data.descripcion} </span>
                  </span>
                  <div>{/** http://localhost:8080/hls/"+canales[c].canal+".m3u8" */}
                    { respuesta[currenCanal.data.canal].url?
                      <ReactHLS
                        url={respuesta[currenCanal.data.canal]? respuesta[currenCanal.data.canal].url: ""}
                        autoplay={ true }
                        constrols= { true }
                        width = {"85%"}
                        //video = {"100%"}
                        height = {"auto"}
                       // video = {"auto"}
                      />
                    :<div>video encontrado {respuesta[currenCanal.data.canal].url}</div>
                    }
                  </div>
                  <div width="200px" height= "200px">
                    { !respuesta[currenCanal.data.canal].url?
                      <rect x="0" y="0" width="150" height="150" style={{fill: "blue", stroke: "pink", "stroke-width": 5, "fill-opacity": 0.1, "stroke-opacity":0.9 }} />
                      :null
                    }
                  </div>
                </div>
              :null
            }
          </div>
          <div className={"col-12"}>
            <div className="row">
              <div className={"col-3"}></div>
              <div hidden={!playingState.wait} className="col" style={{ height: "275px" }}>
                <div className="loader" style={{ width: "250px" ,height: "250px" }}></div>
              </div>
              <div className={"col-3"}></div>
            </div>
          </div>{console.log(respuesta)}
            {currenCanal.data && respuesta[currenCanal.data.canal]?
            <div>{respuesta[currenCanal.data.canal].mensaje}</div>
            : null }
        </div>
      </div>
      <Grid.Col sm={12} lg={12}>
      </Grid.Col>
    </>
  );
}
export default LiveVideo;
